<template>
  <div class="grid gap-4">
    <app-skeleton-block
      class="aspect-[3/4] !h-auto w-full"
      :class="skeletonClass"
    />

    <div class="flex flex-wrap gap-2">
      <app-skeleton-text :class="skeletonClass" :width="100" />
      <app-skeleton-text :class="skeletonClass" />
      <app-skeleton-text :class="skeletonClass" />
    </div>

    <app-skeleton-text class="!w-full" :class="skeletonClass" />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  skeletonClass?: string;
}>();
</script>
